import React from "react";
import styles from "../Widget.module.css";
import style from "./Global.module.css";
export default function GlobalHead() {
  return (
    <div>
      <div className={style.titleDiv}>
        <h2 className={styles.widgetTitle}>OUR GLOBAL PRESENCE</h2>
      </div>
      <div className={style.mainDiv}>
        <div className={style.mainInner}>
          <div className={style.textContainer}>
            <p className={style.heading}>MALAYSIA</p>
            <p className={style.description}>
              F2-2-1, Midfields 2, Sungai Besi, 57100, Kuala Lumpur, Malaysia
            </p>
            <p className={style.footer}>Phone: +60-11-2323-4533</p>
          </div>
        </div>

        <div className={style.mainInner}>
          <div className={style.textContainer}>
            <p className={style.heading}>PAKISTAN</p>
            <p className={style.description}>
              InvoZone, 1st Floor, Commercial 3, Sunflower, Block J1, Johar
              Town, Lahore
            </p>
            <p className={style.footer}>Phone: +92-31-777-111-71</p>
          </div>
        </div>
      </div>
    </div>
  );
}
